import { Goto } from "@/shared/navigation/Goto";

import type { CommentRecord } from "./CommentRecord";

/** The page of the entity a comment is on. */
export function commentEntityRoute(
  comment: Pick<CommentRecord, "entity_type" | "entity_id" | "org_id">,
): string {
  const entityId = comment.entity_id;
  switch (comment.entity_type) {
    case "dataset":
      return Goto.createDatasetRoute(entityId);
    case "file":
      return Goto.createFileRoute(entityId);
    case "action":
      // The service identifies an action as `<org_id>_<name>`, and a comment
      // lives in the org of the entity it is on.
      return Goto.createActionRoute({
        owner: comment.org_id,
        name: entityId.slice(`${comment.org_id}_`.length),
      });
    case "collection":
      return Goto.createCollectionRoute(entityId);
    case "invocation":
      return Goto.createInvocationRoute(entityId);
    case "trigger":
      return Goto.createTriggerRoute(entityId);
  }
}
